import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e283600")

_pushScopeId("data-v-4e283600")
const _hoisted_1 = { id: "visCheckSettings" }
const _hoisted_2 = { class: "settings-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "List ID", -1)
const _hoisted_4 = { class: "settings-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Go to ", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("option", { value: true }, "next", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("option", { value: false }, "previous", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "label" }, "page, if possible", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        type: "text",
        ref: "test",
        class: "componentIdInput",
        onFocus: _cache[1] || (_cache[1] = $event => (_ctx.idWatcher = val => (_ctx.action.targetId = val))),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.action.targetId = $event))
      }, null, 544), [
        [_vModelText, _ctx.action.targetId]
      ])
    ]),
    _createVNode("p", {
      class: ["label", 
        _ctx.components[_ctx.action.targetId] &&
        _ctx.components[_ctx.action.targetId].displayName == 'List'
          ? ''
          : 'red-text'
      ]
    }, " TARGET" + _toDisplayString(!_ctx.components[_ctx.action.targetId]
          ? " NOT FOUND!"
          : _ctx.components[_ctx.action.targetId].displayName != "List"
          ? " is not a list"
          : ": " + _ctx.components[_ctx.action.targetId].name), 3),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createVNode("select", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.action.forward = $event)),
        style: {"margin-right":"8px"}
      }, [
        _hoisted_6,
        _hoisted_7
      ], 512), [
        [_vModelSelect, _ctx.action.forward]
      ]),
      _hoisted_8
    ])
  ]))
})